import { CellIndexId } from './types'

export function isDefined<T>(value: T | null | undefined): value is T {
    return value !== null
}

export function toCellId({ colId, rowId }: { rowId: number | string; colId: number | string }): CellIndexId {
    return `cell::${rowId}::${colId}`
}
